import { render, staticRenderFns } from "./UrgencyConfig.vue?vue&type=template&id=705701a5&scoped=true&lang=pug"
import script from "./UrgencyConfig.vue?vue&type=script&lang=js"
export * from "./UrgencyConfig.vue?vue&type=script&lang=js"
import style0 from "./UrgencyConfig.vue?vue&type=style&index=0&id=705701a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705701a5",
  null
  
)

export default component.exports